import React from "react";
import PropTypes from "prop-types";
import { Query } from "react-apollo";
import gql from "graphql-tag";

import STREAM_QUERY from "stream/queries/stream.graphql";

export default function StreamQuery({ contentFragment, ...props }) {
  const composedQuery = gql`
    ${STREAM_QUERY}
    ${contentFragment}
  `;

  return <Query query={composedQuery} {...props} />;
}

StreamQuery.propTypes = {
  contentFragment: PropTypes.oneOfType([PropTypes.string, PropTypes.object])
    .isRequired,
  children: PropTypes.func.isRequired,
};
